enum ECookieKeys {
  VS_COOKIE_ACCEPTED = 'VSCookieAccepted',
}

export default ECookieKeys;
